import React, { Component } from "react";
import RightSidePannel from "../../../../../rightSidePannelReusable/RightSidePannel";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { create_and_update_restaurant } from "../../../../../../../../store/actions/authAction";
import { AmealioLoader } from "../../../../../../../Loader/AmealioLoader";
import SuggestNewButton from "../../../../../../reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import isEmpty from "../../../../../../../../store/validation/is-Empty";
import { SliderReusableComponent } from "../../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";

export class Cuisine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionButton: false,
      selectedTab: 2,
      all_dress_code_icons: [],
      selected_dress_code: [],
      primary_dress_code: {},
      // allcategory: [
      //   { id: 1, category_name: "Restaurant Type" },
      //   { id: 2, category_name: "Payment Method" },
      //   { id: 3, category_name: "Services Offered" },
      //   { id: 4, category_name: "Food Type" },
      //   { id: 5, category_name: "Cuisine Type" },
      //   { id: 6, category_name: "Health" },
      // ],
      category: "",
      comment: "",
    };
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.dress_codes) &&
      !nextState.hasSetMapProps
    ) {
      let selected_dress_code = nextProps.onboarding.selected_dress_code;
      let primary_dress_code = nextProps.onboarding.primary_dress_code;
      if (
        !isEmpty(nextProps.onboarding.primary_dress_code) &&
        !isEmpty(selected_dress_code[0])
      ) {
        if (
          nextProps.onboarding.primary_dress_code !== "" &&
          isEmpty(selected_dress_code[0]._id) &&
          selected_dress_code.length > 0 &&
          isEmpty(primary_dress_code._id)
        ) {
          selected_dress_code = nextProps.dress_codes.filter((dress) =>
            selected_dress_code.includes(dress._id)
          );
          primary_dress_code = nextProps.dress_codes.filter(
            (dress) => dress._id === primary_dress_code
          )[0];
        }
      }
      let all_dress_code = nextProps.dress_codes.filter(
        (dress) =>
          !selected_dress_code.some((selected) => selected._id === dress._id) &&
          dress.status !== "NOTAPPROVED"
      );
      return {
        all_dress_code_icons: all_dress_code,
        selected_dress_code: !isEmpty(selected_dress_code)
          ? selected_dress_code
          : [],
        primary_dress_code: !isEmpty(primary_dress_code)
          ? primary_dress_code
          : {},
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }
  /****************************************
   * @DESC - Payment Method SELECTOR
   ****************************************/
  onRestaurantSelectorArraySelector = (icon, index) => (e) => {
    let buttonArray = this.state.all_dress_code_icons;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_dress_code;
    let primaryIcon = this.state.primary_dress_code;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_dress_code: Restaurant,
        primary_dress_code: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_dress_code: Restaurant,
      actionButton: true,
    });
  };

  onRestaurantsPrimarySelector = (icon) => (e) => {
    this.setState({
      primary_dress_code: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  removeButton = (icon) => (e) => {
    let {
      all_dress_code_icons,
      selected_dress_code,
      primary_dress_code,
    } = this.state;

    let iconIndexAtAllIcons = all_dress_code_icons.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons = selected_dress_code.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconAtPrimaryIcon =
      !isEmpty(primary_dress_code) && primary_dress_code._id === icon._id
        ? true
        : false;
    if (selected_dress_code.length === 0) {
      selected_dress_code.push(icon);
      all_dress_code_icons.splice(iconIndexAtAllIcons, 1);
      primary_dress_code = icon;
    } else if (iconAtPrimaryIcon) {
      selected_dress_code.splice(iconIndexAtSelectedIcons, 1);
      all_dress_code_icons.push(icon);
      if (selected_dress_code.length === 1) {
        primary_dress_code = selected_dress_code[0];
      } else {
        primary_dress_code = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_dress_code.splice(iconIndexAtSelectedIcons, 1);
      all_dress_code_icons.push(icon);
      if (selected_dress_code.length === 1) {
        primary_dress_code = selected_dress_code[0];
      }
    } else {
      selected_dress_code.push(icon);
      all_dress_code_icons.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_dress_code: selected_dress_code,
      all_dress_code_icons: all_dress_code_icons,
      primary_dress_code: primary_dress_code,
      actionButton: true,
    });
  };

  onWithOutApiCall = (e) => {
    this.props.history.push({
      pathname: "/casual-fine-dining/menusetup/uploadmenu/categorytype",
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    // const formData = {
    //   vendor_id: this.props.auth.user.VendorUser._id,
    //   id: this.props.onboarding._id,
    //   selected_dress_code: this.state.selected_dress_code,
    //   primary_dress_code: this.state.primary_dress_code,
    //   page_completed_till: 10,
    // };
    // this.props.create_and_update_restaurant(formData);
    this.props.history.push(
      "/casual-fine-dining/menusetup/uploadmenu/categorytype"
    );
  };

  renderDressCodeFields = () => {
    const {
      actionButton,
      selected_dress_code,
      primary_dress_code,
      all_dress_code_icons,
    } = this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div className="margin-bottom-chains-onboarding">
            <div className="cuisine-main ">
              <div
                className={
                  all_dress_code_icons.length > 8
                    ? "cuisine-main-padding-border"
                    : ""
                }
              >
                <div
                  id="box-style"
                  className="cuisine-main-padding"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {all_dress_code_icons.map((icon, index) => (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                      src={icon.icon}
                      title={icon.title}
                      onClick={this.onRestaurantSelectorArraySelector(
                        icon,
                        index
                      )}
                    />
                  ))}
                </div>
              </div>
              <div className="suggest-button-heading">
                <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d0c"} />
              </div>
              <div className="f12-500 mt-5">
                The selected cuisines are shown as below
              </div>
              <div
                className="cuisine-main-padding-bottom mt-4"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {selected_dress_code.map((icon, index) => (
                  <ReusableOnboardingMapButton
                    key={index}
                    classsection={
                      icon._id === primary_dress_code._id
                        ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                        : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                    }
                    src={icon.icon}
                    title={icon.title}
                    onClick={this.onRestaurantsPrimarySelector(icon)}
                    displayPrimary={
                      icon._id === primary_dress_code._id ? true : false
                    }
                    displayRemove={true}
                    removeButtonClick={this.removeButton(icon)}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="onboarding-map-setup-screen-autodetect-button">
            {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
            <ReusableOnboardingLink
              buttonTitle="Back Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Back"
              link="/petsallowed"
            />
            <ReusableOnboardingButton
              buttonTitle="Next Button"
              buttonClass={
                selected_dress_code.length <= 0 ||
                isEmpty(primary_dress_code._id)
                  ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                  : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
              }
              disabled={
                selected_dress_code.length <= 0 ||
                isEmpty(primary_dress_code._id)
                  ? true
                  : false
              }
              buttonText="Proceed"
              onClick={actionButton === false ? this.onWithOutApiCall : null}
              buttonType={actionButton === false ? "button" : "submit"}
            />
            {/* </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div
              id="onboarding-scrollbar"
              className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left"
            >
              <div className="col-12">
                <BackLogoIconButton
                  displayBackText={true}
                  displayArrow={true}
                  backButtonClicked={"/casual-fine-dining/menusetup"}
                  notDisplaProgressBar={true}
                />
              </div>
              <div className="display-toggle-stepup-button">
                <RightSidePannel selectedTab={this.state.selectedTab} />
              </div>
              <div className="onboarding_process_screen-button-map">
                {/* <MapSetupScreenTwo /> */}
                <div>
                  <TopTextReusableComponent
                    headingText="Cuisine Type"
                    headingParagraph="Select the type of cuisines you want to provide from this catalogue"
                  />
                </div>
                <Form noValidate onSubmit={this.onHandleSubmit}>
                  {this.renderDressCodeFields()}
                </Form>
              </div>
            </div>
            <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
              <SliderReusableComponent
                // displayBarButton={true}
                displayHamburger={true}
                paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                bottomImage={require("../../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg")}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors && state.errors.errors,
  onboarding: state.onboarding && state.onboarding.restaurantDetails,
  dress_codes: state.category && state.category.dress_code,
});

export default connect(mapStateToProps, { create_and_update_restaurant })(
  withRouter(Cuisine)
);
